import type { IconData } from '@stacksjs/iconify-core'

export const fahrenheit: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M3 7a4 4 0 1 0 8 0a4 4 0 1 0-8 0m24.3 7.12v7.362h11.564c1.707 0 3.399.857 3.774 2.523c.137.609.206 1.231.206 1.842q0 2.41-1.11 3.518q-1.045 1.107-2.873 1.107H27.43v10.119c0 2.256-1.523 4.26-3.776 4.373q-.766.037-1.516.036q-3.396 0-4.768-1.173q-1.37-1.237-1.371-4.234V11.059q0-2.802 1.633-4.43Q19.265 5 22.075 5h19.01c1.706 0 3.381.869 3.723 2.541c.13.635.192 1.279.192 1.889q0 2.41-1.11 3.583q-1.046 1.107-2.874 1.107z\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default fahrenheit
